import React, { Fragment, useEffect } from "react";
import moment from "jalali-moment";

const ModalReportDetail = ({ onCancel, data, getdata }) => {
  useEffect(() => {
    const overlay = document.querySelector(".modal-overlay");
    const listener = () => {
      if (overlay) {
        onCancel();
      }
    };
    overlay.addEventListener("click", listener);
  });

  return (
    <Fragment>
      <div
        style={{ zIndex: "1000000" }}
        className='fixed inset-0 overflow-y-auto '
        aria-labelledby='modal-title'
        role='dialog'
        aria-modal='true'
      >
        <div
          className='flex items-center  min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 transition-opacity ease-in duration-300'
          // transition-opacity ease-in duration-300
          style={{ transition: "opacity 0.25s ease" }}
        >
          <div
            className='fixed inset-0 bg-gray-500 bg-opacity-50  modal-overlay'
            aria-hidden='true'
            // ref={ref}
          ></div>

          <span
            className='hidden sm:inline-block sm:align-middle sm:h-screen'
            aria-hidden='true'
          >
            &#8203;
          </span>

          <div className='inline-block bg-white rounded-2xl overflow-hidden shadow-xl transform transition-all sm:my-8 align-middle sm:max-w-2xl w-full'>
            <div className='bg-white py-9'>
              <div className='max-w-xl mx-auto w-full p-3 md:p-0'>
                <img
                  className='m-2 absolute left-4 top-4'
                  src='/statics/images/close.svg'
                  width='16px'
                  height='16px'
                  alt='arrow'
                  onClick={() => {
                    onCancel();
                  }}
                />

                <>
                  <div className='text-lg'>مشاهده جزییات</div>

                  <div className='grid grid-cols-1 gap-5 my-10 max-w-xs mx-auto'>
                    <div className='flex justify-between items-center'>
                      <div className='font-semibold'>گزارش دهنده:</div>
                      <div>{data?.user}</div>
                    </div>

                    <div className='flex justify-between items-center'>
                      <div className='font-semibold'>تاریخ گزارش:</div>
                      <div>
                        {moment(data?.created_time)
                          .locale("fa")
                          .format("YYYY/MM/DD")}
                      </div>
                    </div>

                    <div className='flex justify-between items-center'>
                      <div className='font-semibold'>توضیحات:</div>
                      <div>{data?.report?.title}</div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ModalReportDetail;
